// test1100
(1100 && 0);
